import { faker } from '@faker-js/faker';
import { User } from '../src/app/shared/model/user/user';

export default function generateUserMockData(): User[] {
  const users: User[] = [];

  for (let i = 1; i <= 100; i++) {
    const firstName = faker.person.firstName();
    const lastName = faker.person.lastName();

    users.push({
      id: i,
      firstName,
      lastName,
      phoneNumber: faker.phone.number({ style: 'international' }),
      email: faker.internet.email({ firstName, lastName }).toLowerCase(),
      status: faker.helpers.arrayElements(['ACTIVE', 'INACTIVE'], 1)[0],
      createdAt: faker.date.past().toISOString(),
    } as User);
  }

  return users;
}
